import Footer from "./Footer"
import Galleryhead from "./Galleryhead"
import Navbarg from "./Navbarg"
import Mygallery from "./Mygallery"

const Gallery = () => {
    return (
        <div id="section10">
            <Navbarg />
            <Galleryhead />
            <Mygallery/>
            <Footer />
        </div>
    );
}

export default Gallery;